import {
  ACTION_ADD_TRANSACTION,
  ACTION_CLEAR_TRANSACTION_STATUSES,
  ACTION_UPDATE_TRANSACTION_STATUS,
} from '../actions/transactions';

export type transactionStatusType = 'pending' | 'success' | 'failed';
export type transactionKlassType = 'EVM' | 'Elrond';

export interface IIntermediateTransactionInfo {
  timeToComplete: number;
  status: transactionStatusType;
  lastUpdate: number;
}

export interface IIntermediateTransaction {
  klass: transactionKlassType;
  chain: string;
  tx: string;
  description: 'Approval' | 'Swap';
  trading: boolean;
  transaction?: IIntermediateTransactionInfo;
}

const transactions = (state: IIntermediateTransaction[] = [], action: any) => {
  switch (action.type) {
  case ACTION_ADD_TRANSACTION:
    return [...state, action.payload];
  case ACTION_UPDATE_TRANSACTION_STATUS:
    return state.map((item) => {
      if (item.tx === action.payload.tx) {
        return {
          ...item,
          transaction: action.payload.info,
        };
      }
      return item;
    });
  case ACTION_CLEAR_TRANSACTION_STATUSES: {
    return [];
  }
  default:
    return state;
  }
};

export default transactions;
